import { useState } from "react";
import styled from "styled-components";
import XookeeperService from "../../Services/XookeeperService";
import Button from "../../../Generic/Button";
import Loader from "../../../Generic/Loader";

const DataDisplay = styled.div`
	margin: 1rem 0 0 0;
	border-radius: 4px;
	line-height: 1.5;
`;

const ErrorMessage = styled.div`
	color: #dc2626;
	padding: 8px 0;
`;

const LoadingContainer = styled.div`
	display: inline-flex;
	align-items: center;
	padding: 10px 16px;
	border-radius: 4px;
`;

const FetchInputDataButton = ({ workflowId, buttonText = "Fetch Data", inputKey }) => {
	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchInputData = async () => {
		setIsLoading(true);
		setError(null);

        const { data, error } = await XookeeperService.getRequiredInternalInputData(workflowId, { inputKey });

        if(data) {
            setData(data);
        }

        if(error) {
            setError(error);
        }

        setIsLoading(false);
	};

	if (isLoading) {
		return (
			<LoadingContainer>
				<Loader />
			</LoadingContainer>
		);
	}

	if (error) {
		return <ErrorMessage>Error: {error}</ErrorMessage>;
	}

	if (data) {
		return (
			<DataDisplay>
				{inputKey} : {data}
			</DataDisplay>
		);
	}

	return <>
        <Button margin="1rem 0" onClick={fetchInputData}>{buttonText}</Button>
    </>;
};

export default FetchInputDataButton;
